import { Check, Close } from "@mui/icons-material";
import React from "react";

export const ActiveCell =  (props: {active: boolean}) => <>{props.active ? <Check className="active-cell--active" /> : <Close className="active-cell--inactive"/> }</>